module.exports = "/cyber/_next/static/images/errorDark-e6965c84cc3ee7c831d9682d86291b6b.png";